(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lustera-bestsellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lustera-bestsellers-carousel')) {
    class LusteraBestsellersCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.activeIndex = 0;
        this.direction = 1;
        this.isPaused = false;
        this.isVisible = false;
        this.scrollFrame = null;
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = Math.max(5, Number(this.dataset.interval) || 9) * 1000;

        if (!this.track || this.slides.length < 2) {
          return;
        }

        this.previousButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1));

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goTo(index));
        });

        this.track.addEventListener('scroll', () => {
          window.cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = window.requestAnimationFrame(() => this.updateFromScroll());
        }, { passive: true });

        this.addEventListener('mouseenter', () => {
          this.isPaused = true;
        });

        this.addEventListener('mouseleave', () => {
          this.isPaused = false;
        });

        this.addEventListener('focusin', () => {
          this.isPaused = true;
        });

        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.isPaused = false;
          }
        });

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver((entries) => {
            this.isVisible = entries[0].isIntersecting;
          }, { threshold: 0.25 });
          this.visibilityObserver.observe(this);
        } else {
          this.isVisible = true;
        }

        this.updateControls();
        this.startAutoplay();
      }

      disconnectedCallback() {
        window.clearInterval(this.autoplayTimer);
        window.cancelAnimationFrame(this.scrollFrame);
        this.visibilityObserver?.disconnect();
      }

      startAutoplay() {
        if (!this.autoplay || this.prefersReducedMotion) {
          return;
        }

        this.autoplayTimer = window.setInterval(() => {
          if (!this.isVisible || this.isPaused || document.hidden) {
            return;
          }

          if (this.activeIndex >= this.slides.length - 1) {
            this.direction = -1;
          } else if (this.activeIndex <= 0) {
            this.direction = 1;
          }

          this.goTo(this.activeIndex + this.direction);
        }, this.interval);
      }

      goTo(index) {
        const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const slide = this.slides[nextIndex];
        const left = slide.offsetLeft - this.track.offsetLeft;

        this.track.scrollTo({
          left,
          behavior: this.prefersReducedMotion ? 'auto' : 'smooth'
        });

        this.activeIndex = nextIndex;
        this.updateControls();
      }

      updateFromScroll() {
        const currentLeft = this.track.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const slideLeft = slide.offsetLeft - this.track.offsetLeft;
          const distance = Math.abs(slideLeft - currentLeft);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex !== this.activeIndex) {
          this.activeIndex = closestIndex;
          this.updateControls();
        }
      }

      updateControls() {
        this.slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', index === this.activeIndex ? 'false' : 'true');
          slide.inert = index !== this.activeIndex;
        });

        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === this.activeIndex ? 'true' : 'false');
        });

        if (this.previousButton) {
          this.previousButton.disabled = this.activeIndex === 0;
        }

        if (this.nextButton) {
          this.nextButton.disabled = this.activeIndex === this.slides.length - 1;
        }
      }
    }

    customElements.define('lustera-bestsellers-carousel', LusteraBestsellersCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lustera-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const splitValues = (value) => value ? value.split('||').filter(Boolean) : [];

    const addOptions = (select, values) => {
      if (!select) return;
      values.sort((a, b) => a.localeCompare(b)).forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
    };

    const initExplorer = async (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const state = root.querySelector('.lustera-explorer-state');
      const grid = root.querySelector('[data-lustera-grid]');
      const loading = root.querySelector('[data-lustera-loading]');
      const pagination = root.querySelector('[data-lustera-pagination]');
      const search = root.querySelector('[data-lustera-search]');
      const range = root.querySelector('[data-lustera-range]');
      const concern = root.querySelector('[data-lustera-concern]');
      const ingredient = root.querySelector('[data-lustera-ingredient]');
      const price = root.querySelector('[data-lustera-price]');
      const priceOutput = root.querySelector('[data-lustera-price-output]');
      const priceMaximum = root.querySelector('[data-lustera-price-maximum]');
      const empty = root.querySelector('[data-lustera-empty]');
      const loadMore = root.querySelector('[data-lustera-load-more]');
      const sort = root.querySelector('[data-lustera-sort]');
      const formButtons = Array.from(root.querySelectorAll('[data-form-value]'));
      const openButton = root.querySelector('[data-lustera-filter-open]');
      const closeButtons = root.querySelectorAll('[data-lustera-filter-close]');
      const initialParameters = new URLSearchParams(window.location.search);
      if (initialParameters.getAll('view').length > 1) {
        const normalizedUrl = new URL(window.location.href);
        normalizedUrl.searchParams.delete('view');
        normalizedUrl.searchParams.set('view', state.dataset.viewName);
        window.history.replaceState({}, '', normalizedUrl.toString());
      }
      if (!initialParameters.has('sort_by') && !window.Shopify?.designMode) {
        const featuredUrl = new URL(window.location.href);
        featuredUrl.searchParams.set('sort_by', 'best-selling');
        featuredUrl.searchParams.set('view', state.dataset.viewName);
        featuredUrl.searchParams.delete('page');
        window.location.replace(featuredUrl.toString());
        return;
      }
      const requestedRange = initialParameters.get('range') || '';
      const requestedConcern = initialParameters.get('concern') || '';
      const requestedIngredient = initialParameters.get('ingredient') || '';
      const requestedForm = initialParameters.get('form') || '';
      const initialLimit = Number(state.dataset.initialLimit || 12);
      let visibleLimit = initialLimit;
      let selectedForm = '';

      const closeFilters = () => {
        document.body.classList.remove('lustera-filters-open');
        if (openButton) openButton.setAttribute('aria-expanded', 'false');
      };

      if (openButton) {
        openButton.addEventListener('click', () => {
          document.body.classList.add('lustera-filters-open');
          openButton.setAttribute('aria-expanded', 'true');
        });
      }
      closeButtons.forEach((button) => button.addEventListener('click', closeFilters));

      const totalPages = Number(state.dataset.totalPages || 1);
      const currentPage = Number(state.dataset.currentPage || 1);

      if (totalPages > 1) {
        const requests = [];
        for (let pageNumber = 1; pageNumber <= totalPages; pageNumber += 1) {
          if (pageNumber === currentPage) continue;
          const pageUrl = new URL(window.location.href);
          pageUrl.searchParams.set('page', String(pageNumber));
          pageUrl.searchParams.set('view', state.dataset.viewName);
          pageUrl.hash = '';
          requests.push(
            fetch(pageUrl.toString(), { credentials: 'same-origin' })
              .then((response) => {
                if (!response.ok) throw new Error('Unable to load product page');
                return response.text();
              })
              .then((html) => {
                const documentCopy = new DOMParser().parseFromString(html, 'text/html');
                return Array.from(documentCopy.querySelectorAll('[data-product-card]'));
              })
          );
        }

        try {
          const pages = await Promise.all(requests);
          pages.flat().forEach((card) => grid.appendChild(card));
          Array.from(grid.querySelectorAll('[data-product-card]'))
            .sort((a, b) => Number(a.dataset.position) - Number(b.dataset.position))
            .forEach((card) => grid.appendChild(card));
          if (pagination) pagination.hidden = true;
        } catch (error) {
          if (pagination) pagination.hidden = false;
        }
      } else if (pagination) {
        pagination.hidden = true;
      }

      const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
      const ranges = new Set();
      const ingredients = new Set();
      let highestPrice = 0;

      cards.forEach((card) => {
        splitValues(card.dataset.range).forEach((value) => ranges.add(value));
        splitValues(card.dataset.ingredients).forEach((value) => ingredients.add(value));
        highestPrice = Math.max(highestPrice, Number(card.dataset.price || 0));
      });

      const concernDefaultLabel = concern.options[0].textContent;
      const updateConcernOptions = () => {
        const selectedRange = range.value;
        const currentConcern = concern.value;
        const availableConcerns = new Set();

        cards.forEach((card) => {
          const cardRanges = splitValues(card.dataset.range);
          if (!selectedRange || cardRanges.includes(selectedRange)) {
            splitValues(card.dataset.concerns).forEach((value) => availableConcerns.add(value));
          }
        });

        concern.replaceChildren();
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = concernDefaultLabel;
        concern.appendChild(defaultOption);
        addOptions(concern, Array.from(availableConcerns));

        concern.value = availableConcerns.has(currentConcern) ? currentConcern : '';
      };

      addOptions(range, Array.from(ranges));
      addOptions(ingredient, Array.from(ingredients));
      updateConcernOptions();

      const roundedMaximum = Math.max(100, Math.ceil(highestPrice / 5) * 5);
      price.max = String(roundedMaximum);
      price.value = String(roundedMaximum);
      priceOutput.textContent = price.dataset.currency + roundedMaximum;
      priceMaximum.textContent = price.dataset.currency + roundedMaximum;

      const updateCount = (count) => {
        root.querySelectorAll('[data-visible-count]').forEach((node) => {
          node.textContent = String(count);
        });
        const label = root.querySelector('[data-product-count-label]');
        if (label) label.textContent = count === 1 ? 'product' : 'products';
      };

      const applyFilters = (resetLimit = false) => {
        if (resetLimit) visibleLimit = initialLimit;
        const query = search.value.trim().toLowerCase();
        const selectedRange = range.value;
        const selectedConcern = concern.value;
        const selectedIngredient = ingredient.value;
        const selectedPrice = Number(price.value);
        const matchingCards = [];

        cards.forEach((card) => {
          const matchesSearch = !query || (card.dataset.search || '').includes(query);
          const matchesRange = !selectedRange || splitValues(card.dataset.range).includes(selectedRange);
          const matchesConcern = !selectedConcern || splitValues(card.dataset.concerns).includes(selectedConcern);
          const matchesIngredient = !selectedIngredient || splitValues(card.dataset.ingredients).includes(selectedIngredient);
          const matchesForm = !selectedForm || splitValues(card.dataset.forms).includes(selectedForm);
          const matchesPrice = Number(card.dataset.price || 0) <= selectedPrice;
          const matches = matchesSearch && matchesRange && matchesConcern && matchesIngredient && matchesForm && matchesPrice;
          if (matches) matchingCards.push(card);
          card.hidden = true;
        });

        matchingCards.slice(0, visibleLimit).forEach((card) => {
          card.hidden = false;
        });

        updateCount(matchingCards.length);
        empty.hidden = matchingCards.length !== 0;
        grid.hidden = matchingCards.length === 0;
        if (loadMore) {
          const remaining = Math.max(0, matchingCards.length - visibleLimit);
          loadMore.hidden = remaining === 0;
          loadMore.textContent = remaining > 0
            ? `${loadMore.dataset.label || 'Load more'} (${remaining} remaining)`
            : (loadMore.dataset.label || 'Load more');
        }
      };

      if (loadMore) {
        loadMore.dataset.label = loadMore.textContent.trim();
        loadMore.addEventListener('click', () => {
          visibleLimit += initialLimit;
          applyFilters();
        });
      }

      search.addEventListener('input', () => applyFilters(true));
      range.addEventListener('change', () => {
        updateConcernOptions();
        applyFilters(true);
      });
      concern.addEventListener('change', () => applyFilters(true));
      ingredient.addEventListener('change', () => applyFilters(true));
      price.addEventListener('input', () => {
        priceOutput.textContent = price.dataset.currency + price.value;
        applyFilters(true);
      });

      formButtons.forEach((button) => {
        button.addEventListener('click', () => {
          selectedForm = button.dataset.formValue;
          formButtons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          applyFilters(true);
        });
      });

      root.querySelectorAll('[data-lustera-clear]').forEach((button) => {
        button.addEventListener('click', () => {
          search.value = '';
          range.value = '';
          concern.value = '';
          updateConcernOptions();
          ingredient.value = '';
          selectedForm = '';
          price.value = String(roundedMaximum);
          priceOutput.textContent = price.dataset.currency + roundedMaximum;
          formButtons.forEach((item) => {
            const active = item.dataset.formValue === '';
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          applyFilters(true);
        });
      });

      if (sort) {
        sort.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      }

      if (requestedRange && ranges.has(requestedRange)) {
        range.value = requestedRange;
        updateConcernOptions();
      }

      if (requestedConcern && Array.from(concern.options).some((option) => option.value === requestedConcern)) {
        concern.value = requestedConcern;
      }

      if (requestedIngredient && ingredients.has(requestedIngredient)) {
        ingredient.value = requestedIngredient;
      }

      const requestedFormButton = formButtons.find((button) => button.dataset.formValue === requestedForm);
      if (requestedFormButton) {
        selectedForm = requestedForm;
        formButtons.forEach((button) => {
          const active = button === requestedFormButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      loading.hidden = true;
      updateCount(cards.length);
      applyFilters();
    };

    document.querySelectorAll('[data-lustera-explorer]').forEach((root) => initExplorer(root));

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-lustera-explorer]');
      if (root) initExplorer(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lustera-featured-month"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-lustera-copy-code]');
    if (!button) return;
    const code = button.dataset.lusteraCopyCode;
    try {
      await navigator.clipboard.writeText(code);
      const original = button.innerHTML;
      button.innerHTML = '<strong>Code copied</strong>';
      window.setTimeout(() => { button.innerHTML = original; }, 1800);
    } catch (error) {
      window.prompt('Copy your discount code:', code);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lustera-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-lustera-hero]';

    function initialiseHero(hero) {
      if (!hero || hero.dataset.initialised === 'true') return;
      hero.dataset.initialised = 'true';

      const slides = Array.from(hero.querySelectorAll('[data-lustera-slide]'));
      const dots = Array.from(hero.querySelectorAll('[data-lustera-dot]'));
      const previous = hero.querySelector('[data-lustera-previous]');
      const next = hero.querySelector('[data-lustera-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const interval = Math.max(Number(hero.dataset.interval) || 11000, 8000);
      let current = 0;
      let timer;
      let pointerStart;

      if (slides.length < 2) return;

      function show(index, restart = true) {
        current = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.inert = !active;
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (restart) start();
      }

      function stop() {
        window.clearInterval(timer);
        timer = undefined;
      }

      function start() {
        stop();
        if (reducedMotion.matches || document.hidden) return;
        timer = window.setInterval(() => show(current + 1, false), interval);
      }

      previous?.addEventListener('click', () => show(current - 1));
      next?.addEventListener('click', () => show(current + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!hero.contains(document.activeElement)) start();
        }, 0);
      });

      hero.addEventListener('pointerdown', (event) => {
        pointerStart = event.clientX;
      });
      hero.addEventListener('pointerup', (event) => {
        if (typeof pointerStart !== 'number') return;
        const distance = event.clientX - pointerStart;
        pointerStart = undefined;
        if (Math.abs(distance) < 50) return;
        show(distance > 0 ? current - 1 : current + 1);
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });
      reducedMotion.addEventListener('change', start);

      hero.addEventListener('shopify:block:select', (event) => {
        const selectedSlide = event.target.closest('[data-lustera-slide]');
        if (!selectedSlide) return;
        stop();
        show(Number(selectedSlide.dataset.index), false);
      });

      show(0, false);
      start();
    }

    function initialiseAll(root = document) {
      root.querySelectorAll(selector).forEach(initialiseHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
